var observer;
var prevCartVariantIds = new Set(); // Track previous cart variant IDs

// Function to update cart UI without making API requests
var updateCartUI = () => {
  var slider_Cart = $('#slidecarthq');
  if (!slider_Cart.length) return;

  // Select the item count div and update only when it changes
  var itemCountDiv = $('#item_count');
  var cartCountText = $('#slidecarthq .cart-count').text().trim();
  if (itemCountDiv.text() !== cartCountText) {
    itemCountDiv.text(cartCountText || "0");
  }
};

// Function to check for cart changes and update stock messages if needed
var checkCartUpdates = () => {
  var slider_Cart = $('#slidecarthq');
  if (!slider_Cart.length) return;

  /* Collecting Variant IDs for Comparison */
  var currentCartVariantIds = new Set();
  $('#slidecarthq .items .item').each(function() {
    var variantId = $(this).attr('data-variant-id');
    if (variantId) currentCartVariantIds.add(variantId);
  });

  // Compare previous and current cart items; only proceed if there's a change
  if (areSetsEqual(prevCartVariantIds, currentCartVariantIds)) {
    return; // No changes detected, so don't make an API request
  }

  // Update previous cart state
  prevCartVariantIds = new Set(currentCartVariantIds);

  // API request to fetch inventory quantity
  fetchInventoryData([...currentCartVariantIds]);
};

// Function to fetch inventory data
var fetchInventoryData = (variantIds) => {
  if (variantIds.length === 0) return;

  var requestData = { variantIds };

  fetch('https://api.bombayhair.ca/pro/inventory-quantity/variant', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(requestData),
  })
    .then(response => response.json())
    .then(data => updateStockMessages(data))
    .catch(error => console.error('Error:', error));
};

// Function to update stock messages in the cart
var updateStockMessages = (inventoryData) => {
  $('#slidecarthq .items .item').each(function() {
    var currentVariantId = $(this).attr('data-variant-id');
    var inventoryInfo = inventoryData[currentVariantId];

    if (!inventoryInfo) return;

    var inventoryQty = inventoryInfo.qty;
    var productId = inventoryInfo.productId;

    // Exclude specific products from update
    if (["7966329602201", "7023857107018", "7023857172554"].includes(productId)) return;

    var message = "";
    if (inventoryQty <= 0) {
      message = "Backorder: Ships Once In Stock";
    } 
    
    var existingMessage = $(this).find('.ibat-cartbackorder');
    if (message && existingMessage.length === 0) {
      $(this).find('.main-top-left').append(`<p class="ibat-cartbackorder">${message}</p>`);
    } else if (!message && existingMessage.length > 0) {
      existingMessage.remove();
    }
  });
};

// Function to compare two sets
var areSetsEqual = (setA, setB) => {
  if (setA.size !== setB.size) return false;
  for (var item of setA) if (!setB.has(item)) return false;
  return true;
};

// Function to observe cart changes
function observeCartChanges() {
  var slider_Cart = $('#slidecarthq');
  if (!slider_Cart.length) return;

  if (observer) observer.disconnect(); // Disconnect existing observer if any

  observer = new MutationObserver(() => {
    updateCartUI(); // Update UI elements
    checkCartUpdates(); // Check for actual cart changes before API request
  });

  observer.observe(slider_Cart[0], { childList: true, subtree: true });

  updateCartUI(); // Initial UI update
  checkCartUpdates(); // Initial API call if needed
}

// Start observing once the cart element is available
var checkCartInterval = setInterval(() => {
  if ($('#slidecarthq').length) {
    clearInterval(checkCartInterval);
    observeCartChanges();
  }
}, 1000); // Check every 1 second until element is found
